// extracted by mini-css-extract-plugin
export default {"List":"styles_List__54Qkq","List__item":"styles_List__item__5fiuX"};